import { Types } from 'mongoose';
import * as dis2 from '../../dispossitions/dispossitions.data';
import { ACTIVITY_TYPE_OUTREACH, ACTIVITY_TYPE_OUTREACH_ID } from '../activity-type.const';
import { OTHER_FEE } from '../payamnets.data';
import {
    OUTREACH_SUBTYPE_GENERAL,
    OUTREACH_SUBTYPE_GENERAL_ID,
    OUTREACH_SUBTYPE_REMAP,
    OUTREACH_SUBTYPE_REMAP_ID,
} from './outreach.const';

export const REMAP = {
    _id: new Types.ObjectId(OUTREACH_SUBTYPE_REMAP_ID),
    label: OUTREACH_SUBTYPE_REMAP,
    description: 'Informational Sessions for incercerated and formerly incarcerated individuals reported to ReMAp',
    defaultDisposition: dis2.OUT_RE_OPEN_PENDING,
    dispositions: [dis2.OUT_RE_OPEN_PENDING, dis2.OUT_RE_COMPLETED, dis2.OUT_RE_CANCELED],
    paymentIn: [OTHER_FEE],
    paymentOut: [OTHER_FEE],
};

const OTHER_OUTREACH = {
    _id: new Types.ObjectId(OUTREACH_SUBTYPE_GENERAL_ID),
    label: OUTREACH_SUBTYPE_GENERAL,
    description: 'Activities that raise awareness and interest (and may also support education)',
    defaultDisposition: dis2.OUT_OTH_OPEN_PENDING,
    dispositions: [dis2.OUT_OTH_OPEN_PENDING, dis2.OUT_OTH_COMPLETED, dis2.OUT_OTH_CANCELLED, dis2.OUT_OTH_OTHER],
    paymentIn: [OTHER_FEE],
    paymentOut: [OTHER_FEE],
};

export const OUTREACH = {
    _id: new Types.ObjectId(ACTIVITY_TYPE_OUTREACH_ID),
    icon: 'outreach',
    label: ACTIVITY_TYPE_OUTREACH,
    description: 'Activities that raise awareness and interest (and may also support education)',
    subTypes: [OTHER_OUTREACH, REMAP],
};
